
export const VanBredaBankId = 'cd7b0165-d729-44ba-9805-726eb65a08bb';
export const BelfiusBankId = 'cdc3eda3-4fcd-40e7-98e0-278e5a6648bb';
